@if (incident(); as i) {
  <a
    class="flex max-h-fit flex-row items-center rounded-2xl rounded-bl-none border-2 border-maintenance-text-secondary border-opacity-40 bg-maintenance-bg p-4 px-6 hover:opacity-80"
    [href]="i.shortlink"
    target="_blank">
    <div class="flex max-h-fit flex-col items-center pr-6">
      @let schedule = dayjs(i.scheduled_for);
      <span class="text-lg text-maintenance-text-secondary">{{ getMonthName(schedule.month()) }}</span>
      <span class="font-heading text-4xl text-maintenance-text-primary">{{ schedule.date() }}</span>
    </div>
    <div class="h-20 w-0 border border-maintenance-text-secondary opacity-40"></div>
    <div class="flex max-h-fit grow flex-col pl-6">
      <span class="truncate break-all font-heading font-semibold text-maintenance-text-primary">{{ i.name }}</span>
      <div class="flex flex-col gap-2 pt-2">
        @if (i.scheduled_for) {
          <span class="flex flex-row items-center gap-2 overflow-hidden text-ellipsis break-words text-sm">
            <pay-icon class="text-maintenance-text-primary" [shape]="IconNames.Timer" [size]="'sm'" />
            <span class="text-maintenance-text-secondary">{{ i.scheduled_for | formatScheduledTime: i.scheduled_until }}</span>
          </span>
        }

        <span class="flex flex-row items-center gap-2 overflow-hidden text-ellipsis break-words text-sm">
          <pay-icon class="text-maintenance-text-primary" [shape]="IconNames.Scope" [size]="'sm'" />
          <span class="line-clamp-1 text-maintenance-text-secondary">
            @if (i.components && i.components.length > 0) {
              {{ 'status.affected-components' | translate }}{{ i.components | componentsToText }}
            } @else {
              {{ description() }}
            }
          </span>
        </span>
      </div>
    </div>
    <div class="-mr-4 -mt-16">
      <pay-icon class="text-maintenance-text-primary" [size]="'md'" [shape]="IconNames.ChevronRight" />
    </div>
  </a>
}
